"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import { useAppShellContext } from "../AppShell.context.mjs";
import AppShell_module_default from "../AppShell.module.mjs";
import { RemoveScroll } from "react-remove-scroll";
import cx from "clsx";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/AppShell/AppShellAside/AppShellAside.tsx
const AppShellAside = factory((_props) => {
	const { classNames, className, style, styles, unstyled, vars, withBorder, zIndex, mod, ...others } = useProps("AppShellAside", null, _props);
	const ctx = useAppShellContext();
	if (ctx.disabled) return null;
	return /* @__PURE__ */ jsx(Box, {
		component: "aside",
		mod: [{ "with-border": withBorder ?? ctx.withBorder }, mod],
		...ctx.getStyles("aside", {
			className: cx({ [RemoveScroll.classNames.zeroRight]: ctx.offsetScrollbars }, className),
			classNames,
			styles,
			style
		}),
		...others,
		__vars: { "--app-shell-aside-z-index": `calc(${zIndex ?? ctx.zIndex} + 1)` }
	});
});
AppShellAside.classes = AppShell_module_default;
AppShellAside.displayName = "@mantine/core/AppShellAside";
//#endregion
export { AppShellAside };

//# sourceMappingURL=AppShellAside.mjs.map